import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import sortby from 'lodash/sortBy';
import deburr from 'lodash/deburr';
import escapeRegExp from 'lodash/escapeRegExp';
import invariant from 'tiny-invariant';

var compareStrategy = function compareStrategy(method) {
  var and = [function (a, b) {
    return Boolean(a && b);
  }, true];
  var or = [function (a, b) {
    return Boolean(a || b);
  }, false];
  var map = {
    and: and,
    '&&': and,
    '&': and,
    or: or,
    '||': or,
    '|': or
  };
  return map[(method || 'and').toLowerCase()] || map.and;
};
/**
 * Lokalizovane vyhledavani dle `fieldName`.
 *
 * Vraci filtrovany seznam `source`.
 *
 * @param {string | Object} [options] Nastaveni vyhldedavani. Pokud je hodnota typy `string` jedna se o `fieldName`.
 * @param {string} [options.fieldName] Field, dle ktereho se vyhledava.
 * @param {number} [options.limit = 7] Limit na pocet vyslednich polozek vystupniho pole.
 * @param {'and' | '&' | '&&' | 'or' | '|' | '||'} [options.method = 'and'] Spojovaci podminka.
 * @param {boolean} [options.onlyString = false] Pokud je `true` bude vracena jen hodnota property `fieldName`.
 * @param {string} [options.searchFieldName = 'search'] Nazev property s vyhladavacimi vektory.
 * @param {Object[]} source
 * @param {string} [searchValue]
 *
 * @returns {string[] | Object[]}
 */
// eslint-disable-next-line @typescript-eslint/ban-types


export default function localizedSearch(options) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var searchValue = arguments.length > 2 ? arguments[2] : undefined;

  var _ref = _extends({
    limit: 7,
    onlyString: false,
    method: 'and',
    searchFieldName: 'search'
  }, typeof options === 'string' ? {
    fieldName: options
  } : options),
      fieldName = _ref.fieldName,
      limit = _ref.limit,
      method = _ref.method,
      onlyString = _ref.onlyString,
      searchFieldName = _ref.searchFieldName;

  invariant(fieldName, 'localizedSearch require option `fieldName` to be set.');
  return function () {
    if (typeof searchValue !== 'string' || searchValue === '') return source;
    var strategy = compareStrategy(method);
    var tokens = /^\s+$/g.test(searchValue) ? [new RegExp("\\s{".concat(searchValue.length, "}"), 'i')] : deburr(searchValue).toLowerCase().split(/\s+/g).filter(Boolean).map(function (i) {
      return new RegExp(escapeRegExp(i), 'i');
    }); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    var f = source.filter(function (o) {
      var _tokens$map;

      return (_tokens$map = tokens.map(function (r) {
        return r.test(o[searchFieldName]);
      })).reduce.apply(_tokens$map, _toConsumableArray(strategy));
    });
    return sortby(f, [function (o) {
      return o[fieldName];
    }]);
  }().slice(0, limit).map(function (x) {
    return onlyString ? x[fieldName] : x;
  });
}